import "./main-layout.scss";
import { Outlet } from "react-router-dom";
import Header from "../common/header/Header";
import Menu from "../common/menu/Menu";
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const MainLayout = () => {
  const [active, setActive] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  // Simulate loading state
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  // Track mouse position for interactive effects
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  const mainVariants = {
    initial: { y: 50, opacity: 0 },
    animate: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const overlayVariants = {
    initial: { opacity: 0 },
    animate: {
      opacity: 1,
      transition: {
        duration: 0.8,
        delay: 0.2,
      },
    },
  };

  return (
    <AnimatePresence mode="wait">
      {!isLoading && (
        <div
          className={`container ${active ? "active" : ""}`}
          style={{
            "--mouse-x": `${mousePosition.x}px`,
            "--mouse-y": `${mousePosition.y}px`,
          }}
        >
          <Header active={active} setActive={setActive} />

          <motion.div className="main-container" variants={mainVariants}>
            <motion.div
              className="main"
              variants={mainVariants}
              onClick={() => active && setActive(false)}
            >
              <div className="content">
                <motion.div className="overlay" variants={overlayVariants}>
                  <Outlet />
                </motion.div>
              </div>
            </motion.div>
          </motion.div>

          <Menu active={active} setActive={setActive} />
        </div>
      )}
    </AnimatePresence>
  );
};

export default MainLayout;
